import { put, call, takeEvery } from 'redux-saga/effects';
import { axiosInstance, apiURL } from 'config';
import toast from 'react-hot-toast';

import {
  loadLangingImagesRequested,
  loadLangingImagesSuccess,
  loadLangingImagesFail,
  storeLangingImageRequested,
  storeLangingImageSuccess,
  storeLangingImageFail,
  deleteLangingImageRequested,
  deleteLangingImageSuccess,
  deleteLangingImageFail,
} from './landingSlice';
import { loadProductEffect } from 'store/products/sagas';

export function* loadLandingImagesEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/get-landing-images`
    );
    if (data?.succeeded) {
      yield put(loadLangingImagesSuccess(data));
    }
  } catch (error: any) {
    yield put(loadLangingImagesFail(error.message));
  }
}

export function* storeLandingImagesEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/set-image-to-landing`,
      action?.payload,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    if (data?.succeeded) {
      yield put(storeLangingImageSuccess(data));
      toast.success('Landing image added.');
    }
  } catch (error: any) {
    yield put(storeLangingImageFail(error.message));
  }
}

export function* deleteLandingImageEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.delete,
      `${apiURL}/delete-landing-image?id=${action.payload.item?.id}`,
    );

    if (data?.result) {
      yield put(deleteLangingImageSuccess(data));
      toast.success('Landing image deleted successfully');
    } else {
      toast.error('Landing image delete failed! ', data?.errors);
    }
  } catch (error: any) {
    yield put(deleteLangingImageFail(error.message));
  }
}

export function* langingImageSaga(): Generator<any, void, any> {
  yield takeEvery(loadLangingImagesRequested, loadLandingImagesEffect);
  yield takeEvery(storeLangingImageRequested, storeLandingImagesEffect);
  yield takeEvery(deleteLangingImageRequested, deleteLandingImageEffect);

}
